import { oz } from '@weft/utils';
import { HomePageInvoiceSummaryComparisonsSchema } from './home-page-invoice-summary-comparisons';
import { HomePageRevenueByBillingStatusSchema } from './home-page-revenue-by-billing-status';

export const HomePageInvoiceSummarySchema = oz.object({
  revenueByBillingStatus: HomePageRevenueByBillingStatusSchema,
  comparisons: HomePageInvoiceSummaryComparisonsSchema,
}).openapi('HomePageInvoiceSummary');

export type HomePageInvoiceSummary = oz.infer<typeof HomePageInvoiceSummarySchema>;